
<main>
  <div class="container">
    <div class="water-reminder-container p-4">
      <div class="water-reminder-header d-flex justify-content-between align-items-center">
        <div>
          <span class="d-block font-weight-bold">Total Water Intake</span>
          <span class="d-block">{{ waterSelectValue }} ml</span>
        </div>
        <i class="ti ti-pencil" (click)="openBottomSheet()"></i>
        <div>
          <span class="d-block font-weight-bold">Achieved Goal Days</span>
          <span class="d-block">{{ totalWaterIntake }} ml</span>
        </div>
      </div>
      <div class="water-reminder-circle my-4">
        <div class="wave" [ngStyle]="{ height: waveHeight + '%' }"></div>
        <div class="circle-text text-center">{{ totalWaterIntake }} ml</div>
      </div>
      <div class="water-amount-buttons btn-group btn-group-toggle d-flex justify-content-center mb-3">
        <button *ngFor="let amount of waterAmounts" class="btn btn-outline-primary" (click)="setWaterAmount(amount)">
          {{ amount }} ml
        </button>
      </div>
      <div class="button-container mb-3">
        <button class="btn btn-primary btn-block" (click)="drinkWater()">
          <i class="material-icons">local_drink</i>
        </button>
      </div>
    </div>
  </div>
</main>